export default __webpack_public_path__ + "static/media/suicide.5c6fdf88.png";